export type PrivilegeLevelDescriptor = {
  name: string;
  value: number;
}

export type SharingStatusDescriptor = {
  name: string;
  value: number;
}

export type ShareeRoleDescriptor = {
  name: string;
  value: number;
}

export class SharingConstants {
  /**********************************************************
   * If changes are made, API code must be updated to match *
   **********************************************************/

  static readonly INVITE_INVITED: number = 2
  static readonly INVITE_ACTIVE: number = 3;  // Must match lookup value
  static readonly TERMINAL_STATES: number[] = [0, 4, 5, 6, 7];  // Must match lookup values
  static readonly VIEW_PRIVILEGE: number = 2;  // Must match lookup value
  static readonly VIEW_UPLOAD_PRIVILEGE: number = 3;  // Must match lookup value

  // Sharing State

  static sharingState: SharingStatusDescriptor[] = [
    { "name": "None or Unknown", "value": 0 },
//    { "name": "Invitation Created", "value": 1 }, NO LONGER USED AS OF V6
    { "name": "Invited", "value": 2 },
    { "name": "Active", "value": 3 },  // Invitation Accepted
    { "name": "Invitation Declined", "value": 4 },
    { "name": "Cancelled by Health Record Owner", "value": 5 },
    { "name": "Invitation Expired", "value": 6 },
    { "name": "Revoked by Health Record Owner", "value": 7 },
    { "name": "Administratively Terminated", "value": 8 },
    { "name": "Revoked by Invitee", "value": 9 }
  ];

  // Sharee Roles
  static shareeRole: ShareeRoleDescriptor[] = [
    { name: "None or Unknown", value: 0 },
    { name: "Healthcare Provider", value: 1 },
    { name: "Parent or Guardian", value: 2 },
    { name: "Survivor", value: 3 },
  ]

  // Sharing Privilege Levels
  static privilegeLevel: PrivilegeLevelDescriptor[] = [
    {
      "name": "", // Access Denied
      "value": 0
    },
    {
      "name": "Owner",
      "value": 1
    },
    {
      "name": "View",
      "value": 2
    },
    {
      "name": "View, Upload Documents",
      "value": 3
    }
  ];


}
